import { memo } from "react";
import ReactMarkdown from "react-markdown";

import { default as classes } from "./_.module.scss";
import { useChatMarkdown } from "./_hooks";
import { type ChatMarkdownProps } from "./_types";

/**
 * ChatMarkdown Component View
 *
 * Renders markdown content using react-markdown with remark-gfm (tables,
 * strikethrough, task lists) and rehype-highlight (syntax highlighting).
 * Replaces the legacy XMarkdown + MarkdownEventHelper.createComponents() approach.
 */
const ChatMarkdown = memo(({ content, streaming }: ChatMarkdownProps) => {
  const { states } = useChatMarkdown({ content, streaming });

  return (
    <div className={classes.chatMarkdown}>
      <ReactMarkdown
        remarkPlugins={states.remarkPlugins}
        rehypePlugins={states.rehypePlugins}
        components={states.components}
      >
        {states.content}
      </ReactMarkdown>
    </div>
  );
});

ChatMarkdown.displayName = "ChatMarkdown";

export default ChatMarkdown;
